<template>
    <a
        :href="props.homeUrl"
        class="nav-logo"
        data-test="nav-logo"
        :title="props.communityName"
        :aria-label="props.communityName">
        <img
            class="nav-logo__image"
            data-test="nav-logo-image"
            :src="props.logoUrl"
            :alt="props.communityName" />
    </a>
</template>

<script lang="ts">
    export interface INavLogoProps {
        communityName: string;
        logoUrl: string;
        homeUrl: string;
    }
</script>

<script setup lang="ts">
    const props = defineProps<INavLogoProps>();
</script>

<style lang="scss">
    @use "./NavLogo.scss";
</style>
